module.exports = __webpack_public_path__ + "img/antes_despues_211.c0f06af8.png";